import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomPagination from "../../common/CustomPagination";
import {
  GetBillingAppointmentStatus,
  GetStatuQueueDataAction,
} from "../../redux/actions/InsBillAction";
import { GetPayoutStatus } from "../../redux/actions/PayoutAction";

export const StatusQueue = ({
  searchFilter,
  setSearchFilter,
  statusQueue
 
}) => {
  function getMonthName(monthNumber) {
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    
    // Since monthNumber is typically 1-12, adjust for zero-based indexing
    return months[monthNumber - 1];
}
  const dispatch = useDispatch();
  const insBillReducer = useSelector((state) => state?.InsBillingPayout);
  const globalReducer = useSelector((state) => state?.globalReducer);

  useEffect(() => {
    dispatch(GetPayoutStatus(false,false))
    dispatch(GetStatuQueueDataAction(searchFilter));
  }, []);

  return (
    <>
      <div className="table-responsive __custom__properties">
        <table className="table">
          <thead>
            <tr className="avanishtbl">
              <th style={{ minWidth: "20px" }}>Insurer Name</th>
              <th style={{ textAlign: "center" }}>Policy Ref No</th>
              <th>Case No</th>
              <th>Docket No</th>
              <th>Customer Name</th>
              <th style={{ textAlign: "center" }}>Month</th>
              {statusQueue !== "unSuccessfullAppointments" && <th style={{ textAlign: "center" }}>Status</th>}
              
              {/* <th style={{ textAlign: "center" }}>Action</th> */}
            </tr>
          </thead>
          {insBillReducer?.getStatusQueueData?.length !== 0 && (
            <tbody>
              {insBillReducer?.getStatusQueueData?.map((ele, index) => {
                return (
                  <tr>
                    <td>{ele?.clientName}</td>
                    <td style={{ textAlign: "center" }}>{ele?.policyRefNo}</td>
                    <td>{ele?.caseNo}</td>
                    <td>{ele?.docketNo}</td>
                    <td>{ele?.proposerName}</td>
                    <td style={{textAlign:"center"}}>{getMonthName(ele?.month)}</td>
                    {statusQueue !== "unSuccessfullAppointments" &&  <td>
                      <p
                        style={{ margin: "auto" }}
                        className={`status-style ${
                          ele?.insurerRequestStatus === "Partial Show"
                            ? "refundStatus"
                            : ele?.insurerRequestStatus === "Report On Hold"
                            ? "reportOnHold" :ele?.insurerRequestStatus === "Report In QC"
                            ? "reportInQc"
                            
                            : "pending"
                        }`}
                      >
                        {" "}
                        {ele?.insurerRequestStatus}
                      </p>
                    </td>}
                   
                    {/* <td style={{ textAlign: "center" }}>
                      <button
                        className="btn search__btn action_export"
                        type="button"
                        onClick={() => {
                          setOpenModel({ ...openModel, moveToBilling: true });
                          setProviderDetail([ele]);
                        }}
                      >
                        Move To Billing
                      </button>
                    </td> */}
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
        {insBillReducer?.getStatusQueueData?.length === 0 && (
          <p className="noRecordFound">No Record Found</p>
        )}
        <div className="d-flex justify-content-center mt-4">
          {globalReducer?.getTotalCount !== 0 && (
            <CustomPagination
              totalCount={globalReducer?.getTotalCount}
              perPageData={searchFilter?.rows}
              searchFilter={searchFilter}
              setSearchFilter={setSearchFilter}
              apiCall={GetStatuQueueDataAction}
            />
          )}
        </div>
      </div>
    </>
  );
};
